import React from 'react';
import './scss/Loader.scss';
import { FaCog } from 'react-icons/fa';

function Loader() {
  return (
    <div className="loader-backdrop">
      <div className="loader-box">
        <div className="gear-animation">
          <FaCog className="gear gear-1" />
          <div className="trail"></div>
        </div>
        <p>Assembling your service request...screw my screw ⚙️🔩🔧</p>
        
      </div>
    </div>
  );
}

export default Loader;
